import { useState, useRef } from 'react';
import api from '../api';

export default function VoiceButton({ onResult, style = {} }) {
  const [recording, setRecording] = useState(false);
  const [processing, setProcessing] = useState(false);
  const mediaRecorder = useRef(null);
  const chunks = useRef([]);

  async function startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream, { mimeType: 'audio/webm;codecs=opus' });
      chunks.current = [];
      recorder.ondataavailable = (e) => { if (e.data.size > 0) chunks.current.push(e.data); };
      recorder.onstop = async () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(chunks.current, { type: 'audio/webm' });
        if (blob.size < 1000) return; // too short
        setProcessing(true);
        try {
          const fd = new FormData();
          fd.append('file', blob, 'voice.webm');
          const { data } = await api.post('/voice/stt', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 30000,
          });
          if (data.text && onResult) onResult(data.text);
        } catch (e) {
          console.error('STT error:', e);
          if (onResult) onResult(null, e.response?.data?.detail || 'Ошибка распознавания');
        }
        setProcessing(false);
      };
      mediaRecorder.current = recorder;
      recorder.start();
      setRecording(true);
      // Auto-stop after 3 min
      setTimeout(() => { if (recorder.state === 'recording') recorder.stop(); setRecording(false); }, 180000);
    } catch (e) {
      console.error('Mic access error:', e);
      if (onResult) onResult(null, 'Нет доступа к микрофону');
    }
  }

  function stopRecording() {
    if (mediaRecorder.current?.state === 'recording') {
      mediaRecorder.current.stop();
    }
    setRecording(false);
  }

  if (processing) {
    return <button className="btn btn-secondary" style={{ ...style, opacity: 0.6 }} disabled>⏳ Распознаю...</button>;
  }

  return (
    <button
      className={`btn ${recording ? 'btn-danger' : 'btn-secondary'}`}
      style={style}
      onMouseDown={startRecording}
      onMouseUp={stopRecording}
      onTouchStart={startRecording}
      onTouchEnd={stopRecording}
    >
      {recording ? '⏹️ Отпустите' : '🎙️'}
    </button>
  );
}
